import { Button, CircularProgress, Tooltip } from "@mui/material";

export const RACTLoadingIconButton = ({
  loading,
  children,
  title,
  ...rest
}) => {
  return (
    <Tooltip title={title} arrow>
      <Button
        disabled={loading}
        sx={{ minWidth: "40px", maxWidth: "40px", padding: 0 }}
        variant="text"
        {...rest}
      >
        {loading ? <CircularProgress size={20} /> : children}
      </Button>
    </Tooltip>
  );
};
